import React from "react";
import { AxiosResponse } from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";
import { IService, IRecordRequest, IMasterRecord } from "app/api/types";
import TIMES from "app/consts/TIMES";
import {
  getRecords,
  addRecord,
  delRecord,
  editRecord
} from "app/api/redux/Records/actions";
import { getServices } from "app/api/redux/Services/actions";
import { getMasters } from "app/api/redux/Masters/actions";

import RecordColumn from "app/components/RecordColumn";
import RecordList from "app/components/RecordList";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";
import getSignedRecords from "../../api/requests/SignedRecords/getSignedRecords";
import getChatToken from "../../api/getChatToken";

interface IState {
  currentDate: string;
  reportFrom: string;
  reportTo: string;
}

interface IProps extends RouteComponentProps<{ id: string }> {
  masterRecordList: IMasterRecord[];
  serviceList: IService[];
  isLoading: boolean;
  getServices: () => Promise<AxiosResponse>;
  getRecords: (date: IRecordRequest["date"]) => Promise<AxiosResponse>;
  addRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
  delRecord: (id: number) => Promise<AxiosResponse>;
  editRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
  getMasters: () => Promise<AxiosResponse>;
}

class RecordsPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      currentDate: moment().format("YYYY-MM-DD"),
      reportFrom: moment().add({ month: -1 }).format("YYYY-MM-DD"),
      reportTo: moment().format("YYYY-MM-DD"),
    };
  }

  downloadReport = () => getSignedRecords(getChatToken(), {
    from: this.state.reportFrom,
    to: this.state.reportTo
  });

  componentDidMount() {
    this.props.getServices().catch(err => {
      console.log(err);
    });

    this.props.getRecords(moment().format("YYYY-MM-DD")).catch(err => {
      console.log(err);
    });

    this.props.getMasters().catch(err => console.log(err));
  }

  onChangeDate = (e: any) => {
    this.setState({ currentDate: e.target.value });
    this.props.getRecords(e.target.value).catch(err => {
      console.log(err);
    });
  };

  render() {
    const tableWrapperStyle = {
      maxWidth: this.props.masterRecordList.length * 140 + 60
    };

    return (
      <LayoutUser classNames="pages-record">
        <div className="record-table" style={tableWrapperStyle}>
          <input
            className="input__date"
            type="date"
            defaultValue={moment().format("YYYY-MM-DD")}
            onChange={this.onChangeDate}
          />

          <div className="table-content-wrapper">
            {!this.props.isLoading && (
              <div className="table-times">
                <p></p>
                {TIMES.slice(0, TIMES.length - 1).map((time, index) => (
                  <p key={index}>{time}</p>
                ))}
              </div>
            )}

            {this.props.masterRecordList.map(master => {
              return (
                <RecordColumn
                  master={master}
                  isLoading={this.props.isLoading}
                  serviceList={this.props.serviceList}
                  addRecord={this.props.addRecord}
                  delRecord={this.props.delRecord}
                  editRecord={this.props.editRecord}
                  getRecords={this.props.getRecords}
                  date={this.state.currentDate}
                  key={master.masterid}
                />
              );
            })}
          </div>

          <div className="record-table-report">
            <h1>Отчёт</h1>
            <label>
              <span>от</span>
              <input
                className="input__date"
                type="date"
                defaultValue={moment().add({ month: -1 }).format("YYYY-MM-DD")}
                onChange={(e) => this.setState({ reportFrom: e.target.value })}
              />
            </label>
            <label>
              <span>до</span>
              <input
                className="input__date"
                type="date"
                defaultValue={moment().format("YYYY-MM-DD")}
                onChange={(e) => this.setState({ reportTo: e.target.value })}
              />
            </label>
            <button onClick={this.downloadReport}>Скачать</button>
          </div>
        </div>

        {this.props.masterRecordList.map(master => {
          return (
            <RecordList
              master={master}
              isLoading={this.props.isLoading}
              serviceList={this.props.serviceList}
              addRecord={this.props.addRecord}
              delRecord={this.props.delRecord}
              editRecord={this.props.editRecord}
              getRecords={this.props.getRecords}
              date={this.state.currentDate}
              key={master.masterid}
            />
          );
        })}
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    masterRecordList: state.records.masterRecordList,
    serviceList: state.services.serviceList,
    isLoading: state.records.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getRecords,
    addRecord,
    delRecord,
    editRecord,
    getMasters,
    getServices
  })(RecordsPage)
);
